import React from "react";
import get from "lodash/get";
import IdOcrFieldRegula from "./IdOcrFieldRegula";
import IdOcrFieldBlink from "./IdOcrFieldBlink";
import IdOcrFieldAlce from "./IdOcrFieldAlce";

const IdOcrField = ({ gizmo }) => {
  const config = gizmo.getConfig();
  const readerType = get(config, "ops.idOcrField.reader");

  if (readerType === "b") {
    return <IdOcrFieldRegula gizmo={gizmo} />;
  }
  if (readerType === "blink") {
  return <IdOcrFieldBlink gizmo={gizmo} />;
  }
  return <IdOcrFieldAlce gizmo={gizmo} />;


  //use with the blink license
    // return <IdOcrFieldBlink gizmo={gizmo} />;

};

export default IdOcrField;
